import user from './user';
import config from './config';
import {ModuleTree} from "vuex";

export default <ModuleTree<any>>{
    user,
    config
};
